import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import store from '../store'
// import { getToken, getLoginId } from '@/utils/auth'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 25000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  if (!config.params) {
    config.params = {}
  }
//   config.params.token = getToken()
//   config.params.loginId = getLoginId()
  if (store.getters.token) {
    // config.headers['X-Token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  return config
  }, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    // console.log('response',response);
  /**
  * code为非20000是抛错 可结合自己业务进行修改
  */
    // 放行指定响应头的资源
    if (response.headers['content-type'] === 'application/vnd.ms-excel;charset=utf-8') {
      return response
    }
    if (response.headers['content-type'] === 'application/pdf') {
      return response
    }
    const res = response.data
    // console.log(JSON.stringify(res));
    if ( res.code * 1 !== 0 && res.code * 1 !== 5000) {
      // res.msg = res.msg ? res.msg : (res.message ? res.message : (res.data.msg ? res.data.msg : '系统错误!'))
      // Message({
      //   // 临时处理，后端返回格式不统一，接口msg位置不同
      //   message: res.msg,
      //   type: 'error',
      //   duration: 5 * 1000
      // })

      // 50008:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        MessageBox.confirm('你已被登出，可以取消继续留在该页面，或者重新登录', '确定登出', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload()// 为了重新实例化vue-router对象 避免bug
          })
          this.$router.push({path: '/login'})
        })
      }else if(res.code === 108) {
        Message({
          message: res.msg,
          type: 'error',
          duration: 5 * 1000
        })
      }else if(res.code === 113){
        MessageBox.confirm('你的验证信息已过期请重新登录!', '确定登出', { //token过期处理
          confirmButtonText: '重新登录',  
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload()// 为了重新实例化vue-router对象 避免bug
          })
          this.$router.push({path: '/login'})
        })
      }
      return Promise.reject(response.data)
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error)// for debug
    Message({
      message: error.msg,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/util/unit/request.js